import { z as e } from "./v1-BlFVAz1H.js";
import { c as a, p as c, a as o, b as n, d as r, l as m, n as s } from "./v2-BSCAhUOH.js";
const t = a.extend({
  term_months: e.number(),
  term_months_defaulted: e.boolean()
}), i = c.extend({
  contract_overview: t
}), p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aggregatedLineItemsSchema: o,
  competitiveAnalysisSchema: n,
  contractOverviewSchema: t,
  distributionSchema: r,
  lineItemSchema: m,
  negotiationInsightSchema: s,
  priceCheckOutputSchema: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  t as c,
  p as l,
  i as p
};
